import { render, staticRenderFns } from "./ProfileRating.vue?vue&type=template&id=b5875d06&scoped=true&"
import script from "./ProfileRating.vue?vue&type=script&lang=js&"
export * from "./ProfileRating.vue?vue&type=script&lang=js&"
import style0 from "./ProfileRating.vue?vue&type=style&index=0&id=b5875d06&lang=scss&scoped=true&"
import style1 from "./ProfileRating.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5875d06",
  null
  
)

export default component.exports